export default {
    SHOW_PREVIEW: "Посмотреть"
};
